export default "__VITE_ASSET__Q9pCRLwv__"